import { createContext, useState, type ReactNode } from "react";

export const SelectionColorContext = createContext<
  (color: string | null) => void
>(() => {});
SelectionColorContext.displayName = "SelectionColorContext";

export function SelectionColorProvider({ children }: { children: ReactNode }) {
  const [color, setColor] = useState<string | null>(null);

  return (
    <SelectionColorContext value={setColor}>
      <div className={color ? `selection-${color}` : undefined}>{children}</div>
    </SelectionColorContext>
  );
}
